import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ThirdPartiesCmp_Organization_Fragment = graphql(`
  fragment ThirdPartiesCmp_Organization_Fragment on Organization {
    _id
    kind
    identifier {
      kind
      value
    }
    name
    tradingName
    statusId
  }
`);

export type ThirdPartiesCmp_Organization = ResultOf<
  typeof ThirdPartiesCmp_Organization_Fragment
>;
